import { IConfigMapping } from './IConfigMapping';

export const General: IConfigMapping = {
    routes: 'routes',
    brand: 'brand'
};
